module.exports = __webpack_public_path__ + "img/logout.f5a313c0.svg";